import PropTypes from "prop-types";
import { useId } from "react";

export default function FormTextInput({
  id,
  label,
  name,
  value,
  defaultValue,
  onChange,
  placeholder,
  type = "text",
  autoComplete,
  disabled,
  error,
  className = "",
  inputClassName = "",
}) {
  const fallbackId = useId();
  const inputId = id || name || fallbackId;
  const isControlled = value !== undefined;

  return (
    <div className={className}>
      <label htmlFor={inputId} className="mb-1 block text-xs font-semibold text-black">
        {label}
      </label>
      <input
        id={inputId}
        name={name}
        type={type}
        placeholder={placeholder}
        autoComplete={autoComplete}
        disabled={disabled}
        aria-invalid={Boolean(error)}
        aria-describedby={error ? `${inputId}-error` : undefined}
        className={[
          "w-full rounded-lg border px-3 py-2.5 text-sm outline-none transition ring-brand-600 focus:ring-2",
          error ? "border-red-400 bg-red-50/40" : "border-slate-500 bg-white",
          inputClassName,
        ].join(" ")}
        {...(isControlled
          ? { value: value ?? "", onChange }
          : { defaultValue, ...(onChange ? { onChange } : {}) })}
      />
      {error ? (
        <p id={`${inputId}-error`} className="mt-1 text-xs font-medium text-red-600" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}

FormTextInput.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  autoComplete: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
};
